import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import { questionValidation } from '../../functions/Validation';
import './address.scss';
import Question from '../question/Question';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faHouse, faSpinner, faHouseCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import { useOutsideClick } from '../../functions/OutsideClick';
import ValidationMessage from '../question/ValidationMessage';
import { tracking } from '../../functions/Tracking';
import { Action } from '../../enums/TrackingActionType';
import { useNavigate, useLocation } from "react-router-dom";
import { getErrorLogIdFromResponse } from '../../functions/ErrorLogging';

export default function Address(props: any) {
    const [question, setQuestion] = useState(props.question);
    const [children, setChildren] = useState(props.question.childInformation);
    const [textValue, setTextValue] = useState(question.answer);
    const [foundAddresses, setFoundAddresses] = useState<any[]>([]);
    const [address, setAddress] = useState<any>();
    const [showAddressInputs, setShowAddressInputs] = useState(false);
    const [searching, setSearching] = useState(false);
    const [noResults, setNoResults] = useState(false);
    const [secondsFocused, setSecondsFocused] = useState(0);
    const timerId = useRef<number>(0);
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

    let navigate = useNavigate();

    const handleClickOutside = () => {
        setNoResults(false);
    };

    const ref = useOutsideClick(handleClickOutside);

    var inputClasses = classNames(
        {
            'postcode-input': true,
            'validation-fail': question.validationFail,
            'short-form-question': question.page === 0
        }
    );

    var labelClasses = classNames(
        {
            'validation-fail-lbl': question.validationFail
        }
    );


    let placeholderText = props.question.placeholder ? props.question.placeholder : "Postcode";

    useEffect(() => {
        setQuestion(props.question);
        if (props.question.answer) {
            setTextValue(props.question.answer);
        }

        if (question.childInformation?.[0]?.answer !== null && question.childInformation?.[0]?.answer !== undefined && question.childInformation?.[0]?.answer !== "") {
            setAddressFromAnswer();
        }
    }, []);

    useEffect(() => {
        if (secondsFocused === 60) {
            //alert("Too much time has passed");
            //alert(question.questionSetQuestion.text);
        }
    }, [secondsFocused]);

    useEffect(() => {
        question.answer = textValue;
    }, [textValue]);

    useEffect(() => {
        setQuestion(question);
        if (address !== "" && address !== null && address !== undefined && question.childInformation !== null) {
            setShowAddressInputs(true);
        }
    }, [address]);

    useEffect(() => {
        if (showAddressInputs) {
            updateChildrenAnswers();
        }
    }, [showAddressInputs]);

    const startTimer = () => {
        timerId.current = window.setInterval(() => {
            setSecondsFocused(prev => prev + 1);
        }, 1000)
    }

    const stopTimer = () => {
        window.clearInterval(timerId.current);
        setSecondsFocused(0);
    }

    const updateAnswer = (e: React.ChangeEvent<HTMLInputElement>) => {
        setTextValue(e.target.value);
        setFoundAddresses([]);
        setNoResults(false);
    }

    const validateAnswer = () => {
        stopTimer();
        tracking(Action.SAVE_QUESTIONS, question.questionSetQuestion.questionID);
        question.validationFail = !questionValidation(question);

        setQuestion(question);
    }

    const searchPostcode = (postcode: string) => {
        setSearching(true);
        if (postcode !== "" && postcode !== null && postcode !== undefined) {
            fetch(`${apiBaseUrl}customer/searchpostcode/${postcode}`)
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    setSearching(false);
                    if (data.object !== "") {
                        let foundAddresses = JSON.parse(data.object);
                        setFoundAddresses(foundAddresses);
                    } else {
                        setNoResults(true);
                    }
                }).catch((error) => {
                    let errorLogId = getErrorLogIdFromResponse(error);
                    localStorage.setItem("errorLogId", errorLogId);
                    navigate('/Error');
                    setSearching(false);
                    setNoResults(true);
                });
        } else {
            setSearching(false);
            setNoResults(true);
        }
    }

    const selectAddress = (index: number) => {
        let selectedAddress = foundAddresses[index];
        delete selectedAddress.extensionData;
        setAddress(selectedAddress);
        question.validationFail = false;
        setQuestion(question);
        props.setCustomerDetailsAddress(foundAddresses[index]);
        setFoundAddresses([]);
    }

    const setAddressInputDisplay = () => {
        question.validationFail = false;
        setQuestion(question);
        if (address == null || address === "" || address === undefined) {
            let emptyAddress = {
                "house": "",
                "street": "",
                "locality": "",
                "city": "",
                "country": "",
                "county": "",
                "postcode": ""
            };
            setAddress(emptyAddress);
            
        } else {
            setShowAddressInputs(true);
        }
    }

    const updateChildrenAnswers = () => {
        question.childInformation.map((childQuestion: any) => {
            switch (childQuestion.questionSetQuestion.text.toLowerCase()) {
                case 'house':
                    if (address.house.length > 0) {
                        childQuestion.answer = address.house;
                    }
                    break;
                case 'street':
                    if (address.street.length > 0) {
                        childQuestion.answer = address.street;
                    }
                    break;
                case 'locality':
                    if (address.locality.length > 0) {
                        childQuestion.answer = address.locality;
                    }
                    break;
                case 'town':
                    if (address.locality.length > 0) {
                        childQuestion.answer = address.locality;
                    }
                    break;
                case 'city':
                    if (address.city.length > 0) {
                        childQuestion.answer = address.city;
                    }
                    break;
                case 'country':
                    if (address.country !== null && address.country !== undefined) {
                        if (address.country.length > 0) {
                            childQuestion.answer = address.country;
                        }
                    } else {
                        childQuestion.answer = "United Kingdom";
                    }
                    
                    break;
                case 'county':
                    if (address.county.length > 0) {
                        childQuestion.answer = address.county;
                    }
                    break;
                case 'postcode':
                    if (address.postcode.length > 0) {
                        childQuestion.answer = address.postcode;
                    }
                    break;
                default:
                    childQuestion.answer = "";
                    break;
            }
            childQuestion.questionSetQuestion.visible = true;
            return childQuestion;
        });

        setChildren([...question.childInformation]);
    }

    const setAddressFromAnswer = () => {
        let inputAddress = {
            "house": "",
            "street": "",
            "locality": "",
            "city": "",
            "country": "",
            "county": "",
            "postcode": ""
        };

        question.childInformation.map((childQuestion: any) => {
            switch (childQuestion.questionSetQuestion.text.toLowerCase()) {
                case 'house':
                    inputAddress.house = childQuestion.answer;
                    break;
                case 'street':
                    inputAddress.street = childQuestion.answer;
                    break;
                case 'locality':
                    inputAddress.locality = childQuestion.answer;
                    break;
                case 'town':
                    inputAddress.locality = childQuestion.answer;
                    break;
                case 'city':
                    inputAddress.city = childQuestion.answer;
                    break;
                case 'country':
                    inputAddress.country = childQuestion.answer;
                    break;
                case 'county':
                    inputAddress.county = childQuestion.answer;
                    break;
                case 'postcode':
                    inputAddress.postcode = childQuestion.answer;
                    break;
                default:
                    inputAddress.postcode = childQuestion.answer;
                    break;
            }
            return childQuestion;
        });

        setAddress(inputAddress);
    }

    return (
        <>
            <div className="question">
                <label className={labelClasses} htmlFor={"valen_" + question.questionSetQuestion.questionID}>{question.questionSetQuestion.text}</label>
                <br />
                {!showAddressInputs &&
                    <div className="search-container">
                        <div className="search-inner">
                            <input
                                type="text"
                                value={textValue}
                                id={"valen_" + question.questionSetQuestion.questionID}
                                className={inputClasses}
                                onChange={(e) => updateAnswer(e)}
                                onFocus={() => startTimer()}
                                onBlur={() => validateAnswer()}
                                onKeyUp={(event) => {
                                    if (event.key === "Enter") {
                                        searchPostcode(textValue);
                                    }
                                }}
                                placeholder={placeholderText}
                            />
                            {!searching && <button className="btn-address icon" onClick={() => searchPostcode(textValue)}><FontAwesomeIcon icon={faMagnifyingGlass} /></button>}
                            {searching && <button className="btn-address icon searching"><FontAwesomeIcon icon={faSpinner} spinPulse /></button>}

                            <br />
                            {question.childInformation &&
                            <span className="enter-manually" onClick={() => setAddressInputDisplay()}>Enter address manually</span>
                            }
                        </div>
                        <div className="dropdown">
                            {noResults && <div ref={ref} className="dropdown-row no-results"><FontAwesomeIcon className="error-icon" icon={faHouseCircleExclamation} /> No addresses found</div>}
                            {foundAddresses.map((address, index) => (
                                <div className="dropdown-row" key={index} onClick={() => selectAddress(index)}>{address.house + ", " + address.street + ", " + address.locality + ", " + address.city + ", " + address.postcode}</div>
                            ))}
                        </div>
                    </div>
                }

                {showAddressInputs &&
                    <div className="address-container">
                        {children.map((childQuestion: any, index: any) => {
                            return <Question question={childQuestion} key={childQuestion.questionSetQuestion.questionID} showConditionQuestions={props.showConditionQuestions} enableQuestions={props.enableQuestions} page={props.page} setIndividualCustomerDetails={props.setIndividualCustomerDetails} showConditionalChildren={props.showConditionalChildren} questionIdPosition={props.questionIdPosition} resetRelatedQuestionsValidationOnAnswerChange={props.resetRelatedQuestionsValidationOnAnswerChange} />
                        }
                        )}
                    </div>
                }

                <div>
                </div>
                {question.validationFail && !showAddressInputs && question.childInformation &&
                    <ValidationMessage question={question} overrideMessage="Please enter a valid postcode, click search and select your address. Alternatively select to enter your address manually." />}
                {question.validationFail && showAddressInputs && question.childInformation &&
                    <ValidationMessage question={question} overrideMessage="Please enter a valid address" />}
                {question.validationFail && !showAddressInputs && !question.childInformation &&
                    <ValidationMessage question={question} overrideMessage="" />}
            </div>
        </>
    );
}